import Includded from "./Included";
import Confirm from "./Confirm";
import Amenities from "./Amenities";
import Parking from "./Parking";

// Map of chapterdef KEY: Component
export default {
  INCLUDED: Includded,
  PARKING: Parking,
  AMENITIES: Amenities,
  CONFIRM: Confirm,
};
